import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert'; // @ts-expect-error importing from JS file

import KnowledgeBaseLink from 'AdsUI/components/KnowledgeBaseLink'; // @ts-expect-error importing from JS file

import { KBArticles } from 'AdsUI/lib/Constants';

/**
 * Banner displayed on the events page when the user has Facebook events that
 * they need to migrate to CAPI.
 */
const FacebookCapiReplaceEventsBanner = ({
  numEventsToMigrate,
  onClose
}) => {
  return /*#__PURE__*/_jsxs(UIAlert, {
    closeable: true,
    onClose: onClose,
    type: "warning",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "events.banners.facebookCapiReplaceEventsBanner.title",
      options: {
        count: numEventsToMigrate
      }
    }),
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "events.banners.facebookCapiReplaceEventsBanner.body"
    }), "\xA0", /*#__PURE__*/_jsx(KnowledgeBaseLink, {
      kbArticle: KBArticles.SYNC_FB_CONVERSION_EVENTS,
      context: "fb-capi-replace-events-banner",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "events.banners.facebookCapiReplaceEventsBanner.learnMore"
      })
    })]
  });
};

export default FacebookCapiReplaceEventsBanner;